export default "__VITE_ASSET__Dq3b1Q_U__"